import { render, staticRenderFns } from "./PlateHealthPriority.vue?vue&type=template&id=094c830e&scoped=true&"
import script from "./PlateHealthPriority.vue?vue&type=script&lang=js&"
export * from "./PlateHealthPriority.vue?vue&type=script&lang=js&"
import style0 from "./PlateHealthPriority.vue?vue&type=style&index=0&id=094c830e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094c830e",
  null
  
)

export default component.exports